export const MenuClaims = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size * 0.739}
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5 6.3C10.4 2.7 0 0 0 0C0 0 7.6 11.6 12.5 15.1C16.5 17.9 20.5 17.3 21.9 15.1C23.4 12.8 22.9 8.3 18.5 6.3ZM20.2 13.8C19.3 15.3 16.8 15.4 14.7 14C12.6 12.7 11.6 10.4 12.6 8.9C13.5 7.4 16 7.3 18.1 8.7C20.2 10 21.2 12.3 20.2 13.8Z"
      fill="currentColor"
    />
  </svg>
)
